import { ENEMIES } from '../../data/enemies';
import type { Enemy, EnemyDefinition, EnemyType, RunState } from '../../types';
import { tierFor } from './Reputation';

const TIERS: Record<'low' | 'mid' | 'high', EnemyType[]> = {
  low: ['goblin', 'wolf'],
  mid: ['bandit', 'ogre'],
  high: ['ogre', 'wraith'],
};

let counter = 0;

function pick<T>(arr: readonly T[]): T {
  return arr[Math.floor(Math.random() * arr.length)]!;
}

export function generateEnemy(run: RunState): Enemy {
  const tier = tierFor(run.reputation);
  const candidates = TIERS[tier];
  const type = pick(candidates);
  const def = ENEMIES[type] as EnemyDefinition;
  return {
    id: `enemy_${Date.now().toString(36)}_${counter++}`,
    type: def.type,
    displayName: def.displayName,
    maxHp: def.maxHp,
    hp: def.maxHp,
    silhouetteId: def.silhouetteId,
    fatigueThreshold: def.fatigueThreshold,
    fatigue: 0,
    attackBag: def.attackBag,
    goldRange: def.goldRange,
    backgroundId: def.backgroundId,
    tier: def.tier,
  };
}

/** Picks the next attack pattern for an enemy from its attack bag. */
export function pickNextAttack(enemy: Enemy): Enemy['attackBag'][number] {
  return pick(enemy.attackBag);
}
